import React from 'react';
import { HeroSection } from './components/HeroSection';
import { FeaturesSection } from './components/FeaturesSection';
import { TrustSection } from './components/TrustSection';
import { Footer } from './components/Footer';
export function App() {
  return <main className="min-h-screen w-full font-sans text-navy bg-light selection:bg-emerald-500/30" data-id="element-0">
      <HeroSection data-id="element-1" />
      <FeaturesSection data-id="element-2" />
      <TrustSection data-id="element-3" />
      <Footer data-id="element-4" />
    </main>;
}